import { Instance, destroy, detach, flow, types } from 'mobx-state-tree';

import { createMeetSlot, getMeetSlots } from '@common/api/meetSlots';
import PeriodModel from '@common/models/PeriodModel';
import ReworkingSlot from '@common/models/Reworkings/ReworkingSlot';

import { MAX_HOUR, MIN_HOUR, getDaySlotMap, getSlotMap } from './constants';

const ReworkingSlots = types
	.compose(
		PeriodModel,
		types.model({
			data: types.optional(types.array(ReworkingSlot), []),
			service_id: types.number,
			location_id: types.number,
			group_id: types.maybe(types.number),
			teacher_id: types.maybe(types.number),
			limit: 300,
			slotDuration: types.optional(types.number, 20),
		}),
	)
	.named('ReworkingSlots')
	.views((self) => ({
		get slotsInHour() {
			return Math.trunc(60 / self.slotDuration);
		},
	}))
	.views((self) => ({
		get daysMap() {
			const result = getSlotMap(self.slotsInHour);
			self.data.forEach((item) => {
				result[item.weekday][item.hourNumber][item.hourSlotNumber] = item;
			});
			return result;
		},
		get slotsMap() {
			const result = getDaySlotMap(self.slotsInHour);
			self.data.forEach((item) => {
				result[item.weekday][item.lessonSlotNumber] = item;
			});
			return result;
		},
		get maxHour() {
			return MAX_HOUR;
		},
		get minHour() {
			return MIN_HOUR;
		},
	}))
	.actions((self) => ({
		_fetch: (query: any) =>
			getMeetSlots({
				...query,
				type: 'working_off',
				// location_id: self.location_id,
				group_id: self.group_id,
				period_start: self.period_start,
				period_end: self.period_end,
				teacher_id: self.teacher_id,
			}),
		addSlot: flow(function* (data: any) {
			const result = yield createMeetSlot({
				type: 'working_off',
				location_id: self.location_id,
				service_id: self.service_id,
				teacher_id: self.teacher_id,
				...data,
			});
			self.data.push(result);
		}),
		removeSlot(slot: any) {
			detach(slot);
			destroy(slot);
		},
	}));

export default ReworkingSlots;

export interface IReworkingSlotsModel extends Instance<typeof ReworkingSlots> {}
